import { defineMessages } from 'react-intl'

const scope = `procurify.components.UserSelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Select a user',
  },
})
